import type { IReactionDisposer } from 'mobx';
import { reaction } from 'mobx';
import { useEffect, useState } from 'react';
import type { BoolFunction } from './types';
import type { IBaseViewModel } from '@/engine/app/interfaces.ts';

export const useSelect = (itemVMs: Array<IBaseViewModel> | undefined): { isSelected: BoolFunction } => {
  const [selected, setSelected] = useState<string | undefined>(undefined);
  const isSelected: BoolFunction = (descriptor) => selected === descriptor;

  const totalItems = itemVMs?.length;

  useEffect(() => {
    const selectionReactionDisposers: Array<IReactionDisposer> = [];

    if (itemVMs) {
      const selectedMeasurement = itemVMs.find((objs) => objs.isSelected === true);
      setSelected(selectedMeasurement?.descriptor);
      itemVMs.forEach((viewModel) => {
        selectionReactionDisposers.push(
          reaction(
            () => viewModel.isSelected,
            (objectSelected: boolean) => {
              if (objectSelected) {
                setSelected(viewModel.descriptor);
              } else {
                setSelected(undefined);
              }
            }
          )
        );
      });
    }
    return (): void => {
      selectionReactionDisposers.forEach((disposer) => disposer());
    };
  }, [itemVMs, totalItems]);
  return { isSelected };
};
